export default __webpack_public_path__ + "static/media/ELON.d0ffbcfb.png";